import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  _UInt___init__impl__l7qpdltd1eeof8nsuj as _UInt___init__impl__l7qpdl,
  UInt__toString_impl_dbgl213fqto411a11p0 as UInt__toString_impl_dbgl21,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  _ULong___init__impl__c78o9k1p6qzv0dh0bvg as _ULong___init__impl__c78o9k,
  ULong__toString_impl_f9au7kivnvhcxkib53 as ULong__toString_impl_f9au7k,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import {
  _UByte___init__impl__g9hnc43ude1dscg1q30 as _UByte___init__impl__g9hnc4,
  UByte__toString_impl_v72jg2vnfngefiworp as UByte__toString_impl_v72jg,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import {
  _UShort___init__impl__jigrne2jag2u7194ozm as _UShort___init__impl__jigrne,
  UShort__toString_impl_edaoee3e5ovvzk9wm4f as UShort__toString_impl_edaoee,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ComposerClass;
function Composer() {
  if (ComposerClass === VOID) {
    class $ {
      constructor(writer) {
        this.p2b_1 = writer;
        this.q2b_1 = true;
      }
      r2b() {
        this.q2b_1 = true;
      }
      s2b() {
        return Unit_instance;
      }
      t2b() {
        this.q2b_1 = false;
      }
      u2b() {
        this.q2b_1 = false;
      }
      v2b() {
        return Unit_instance;
      }
      w2b(v) {
        return this.p2b_1.x2b(v);
      }
      y2b(v) {
        return this.p2b_1.z2b(v);
      }
      a2c(v) {
        return this.p2b_1.z2b(v.toString());
      }
      b2c(v) {
        return this.p2b_1.z2b(v.toString());
      }
      c2c(v) {
        return this.p2b_1.d2c(fromInt(v));
      }
      e2c(v) {
        return this.p2b_1.d2c(fromInt(v));
      }
      f2c(v) {
        return this.p2b_1.d2c(fromInt(v));
      }
      g2c(v) {
        return this.p2b_1.d2c(v);
      }
      h2c(v) {
        return this.p2b_1.z2b(v.toString());
      }
      i2c(value) {
        return this.p2b_1.j2c(value);
      }
    }
    initMetadataForClass($, 'Composer');
    ComposerClass = $;
  }
  return ComposerClass;
}
function Composer_0(sb, json) {
  return json.u27_1.l29_1 ? new (ComposerWithPrettyPrint())(sb, json) : new (Composer())(sb);
}
var ComposerForUnsignedNumbersClass;
function ComposerForUnsignedNumbers() {
  if (ComposerForUnsignedNumbersClass === VOID) {
    class $ extends Composer() {
      constructor(writer, forceQuoting) {
        super(writer);
        this.m2c_1 = forceQuoting;
      }
      f2c(v) {
        if (this.m2c_1) {
          // Inline function 'kotlin.toUInt' call
          var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
          this.i2c(UInt__toString_impl_dbgl21(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toUInt' call
          var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
          this.y2b(UInt__toString_impl_dbgl21(tmp$ret$1));
        }
      }
      g2c(v) {
        if (this.m2c_1) {
          // Inline function 'kotlin.toULong' call
          var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
          this.i2c(ULong__toString_impl_f9au7k(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toULong' call
          var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
          this.y2b(ULong__toString_impl_f9au7k(tmp$ret$1));
        }
      }
      c2c(v) {
        if (this.m2c_1) {
          // Inline function 'kotlin.toUByte' call
          var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
          this.i2c(UByte__toString_impl_v72jg(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toUByte' call
          var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
          this.y2b(UByte__toString_impl_v72jg(tmp$ret$1));
        }
      }
      e2c(v) {
        if (this.m2c_1) {
          // Inline function 'kotlin.toUShort' call
          var tmp$ret$0 = _UShort___init__impl__jigrne(v);
          this.i2c(UShort__toString_impl_edaoee(tmp$ret$0));
        } else {
          // Inline function 'kotlin.toUShort' call
          var tmp$ret$1 = _UShort___init__impl__jigrne(v);
          this.y2b(UShort__toString_impl_edaoee(tmp$ret$1));
        }
      }
    }
    initMetadataForClass($, 'ComposerForUnsignedNumbers');
    ComposerForUnsignedNumbersClass = $;
  }
  return ComposerForUnsignedNumbersClass;
}
var ComposerForUnquotedLiteralsClass;
function ComposerForUnquotedLiterals() {
  if (ComposerForUnquotedLiteralsClass === VOID) {
    class $ extends Composer() {
      constructor(writer, forceQuoting) {
        super(writer);
        this.p2c_1 = forceQuoting;
      }
      i2c(value) {
        if (this.p2c_1) {
          super.i2c(value);
        } else {
          super.y2b(value);
        }
      }
    }
    initMetadataForClass($, 'ComposerForUnquotedLiterals');
    ComposerForUnquotedLiteralsClass = $;
  }
  return ComposerForUnquotedLiteralsClass;
}
var ComposerWithPrettyPrintClass;
function ComposerWithPrettyPrint() {
  if (ComposerWithPrettyPrintClass === VOID) {
    class $ extends Composer() {
      constructor(writer, json) {
        super(writer);
        this.s2c_1 = json;
        this.t2c_1 = 0;
      }
      r2b() {
        this.q2b_1 = true;
        this.t2c_1 = this.t2c_1 + 1 | 0;
      }
      s2b() {
        this.t2c_1 = this.t2c_1 - 1 | 0;
      }
      t2b() {
        this.q2b_1 = false;
        this.y2b('\n');
        // Inline function 'kotlin.repeat' call
        var times = this.t2c_1;
        var inductionVariable = 0;
        if (inductionVariable < times)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.y2b(this.s2c_1.u27_1.n29_1);
          }
           while (inductionVariable < times);
      }
      u2b() {
        if (this.q2b_1)
          this.q2b_1 = false;
        else {
          this.t2b();
        }
      }
      v2b() {
        this.w2b(_Char___init__impl__6a9atx(32));
      }
    }
    initMetadataForClass($, 'ComposerWithPrettyPrint');
    ComposerWithPrettyPrintClass = $;
  }
  return ComposerWithPrettyPrintClass;
}
//region block: exports
export {
  ComposerForUnquotedLiterals as ComposerForUnquotedLiterals3v0rwxdudtla9,
  ComposerForUnsignedNumbers as ComposerForUnsignedNumbers2h1dv6l9z3aef,
  Composer_0 as Composer1pt8hwk95abxi,
};
//endregion

//# sourceMappingURL=Composers.mjs.map
